import { useState } from "react";
import { Col, Container, Nav, NavDropdown, Navbar, Row } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import logo from "../resources/logo.png";
const DcNav = () => {
  const [showNavItem, setShowNavItem] = useState(false);
  // pc nav 밑부분
  const NavItem = () => {
    return (
      <div
        className="bg-light position-absolute w-100 d-none d-xl-block"
        onMouseLeave={() => setShowNavItem(false)}
      >
        <Container
          fluid
          className="d-flex pt-2 text-start text-xl-center justify-content-end"
        >
          <Row>
            <div className="col sub-nav-menu">
              <div className="mb-2">
                <a href="/guide/#outline" style={{ color: "#6c757d" }}>
                  대회 안내
                </a>
              </div>
              <div className="mb-2">
                <a href="/guide/#howto" style={{ color: "#6c757d" }}>
                  참가 신청 방법
                </a>
              </div>
              <div className="mb-2">
                <a href="/guide/#prize" style={{ color: "#6c757d" }}>
                  시
                  <span
                    style={{ display: "inline-block", width: "2rem" }}
                  ></span>
                  상
                </a>
              </div>
              <div className="mb-2">
                <a href="/guide/#gift" style={{ color: "#6c757d" }}>
                  기
                  <span
                    style={{ display: "inline-block", width: "0.6rem" }}
                  ></span>
                  념
                  <span
                    style={{ display: "inline-block", width: "0.6rem" }}
                  ></span>
                  품
                </a>
              </div>
              <div className="mb-2">
                <a href="/guide/#note" style={{ color: "#6c757d" }}>
                  유의사항
                </a>
              </div>
            </div>
            <div className="col sub-nav-menu">
              {/* <div className="mb-2">
                <a href="/course/#ultra" style={{ color: "#6c757d" }}>
                  울트라35
                </a>
              </div> */}
              <div className="mb-2">
                <a href="/course/#half" style={{ color: "#6c757d" }}>
                  하프코스
                </a>
              </div>
              <div className="mb-2">
                <a href="/course/#mini" style={{ color: "#6c757d" }}>
                  미니코스
                </a>
              </div>
              <div className="mb-2">
                <a href="/course/#health" style={{ color: "#6c757d" }}>
                  건강코스
                </a>
              </div>
            </div>

            <div className="col sub-nav-menu">
              <div className="mb-2">
                <Link to="/apply/individual" style={{ color: "#6c757d" }}>
                  개인 신청
                </Link>
              </div>
              <div className="mb-2">
                <Link to="/apply/group" style={{ color: "#6c757d" }}>
                  단체 신청
                </Link>
              </div>
              <div className="mb-2">
                <Link to="/apply/search" style={{ color: "#6c757d" }}>
                  조회 및 수정
                </Link>
              </div>
              <div className="mb-2">
                <Link to="/apply/searchId" style={{ color: "#6c757d" }}>
                  접수 번호 조회
                </Link>
              </div>
            </div>
            <div className="col sub-nav-menu">
              <div className="mb-2">
                <Link to="/record" style={{ color: "#6c757d" }}>
                  개인기록 조회
                </Link>
              </div>
              <div className="mb-2">
                <Link to="/record/total" style={{ color: "#6c757d" }}>
                  종합기록 조회
                </Link>
              </div>
              <div className="mb-2">
                <Link
                  to="/record/rank"
                  style={{ color: "#6c757d", letterSpacing: "3px" }}
                >
                  언텍트 순위
                </Link>
              </div>
              <div className="mb-2">
                <Link
                  to="/record/untact"
                  style={{ color: "#6c757d", letterSpacing: "3px" }}
                >
                  언텍트 기록
                </Link>
              </div>

              {/* <div className="mb-2">
                <Link to="/record/print-record" style={{ color: '#6c757d' }}>
                  기록증
                  <span
                    style={{ display: 'inline-block', width: '1.2rem' }}
                  ></span>
                  출력
                </Link>
              </div> */}
            </div>
            <div className="col sub-nav-menu">
              <div className="mb-2 ">
                <Link
                  to="/dashboard/notice?pageNo=1"
                  style={{ color: "#6c757d" }}
                >
                  공지사항
                </Link>
              </div>
              <div className="mb-2">
                <Link to="/dashboard/qna?pageNo=1" style={{ color: "#6c757d" }}>
                  Q&A
                </Link>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    );
  };
  return (
    // nav bar 전체
    <div className="fixed-top noselect">
      <Navbar
        expand="xl"
        className="pb-0 navbar-dark"
        style={{ backgroundColor: "rgba(0,0,0,0.8)" }}
      >
        <Container fluid>
          <NavLink to="/" className="navbar-brand ms-4">
            <img alt="http://www.dcmarathon.or.kr" src={logo} height={30} />
          </NavLink>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            style={{ border: "none", color: "white" }}
          />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end text-start text-xl-center"
          >
            <Nav onMouseEnter={() => setShowNavItem(true)}>
              <Row>
                <Col>
                  <NavLink
                    className="text-white d-none d-xl-block"
                    to="/guide/#outline"
                  >
                    대회 안내
                  </NavLink>
                </Col>
                <Col>
                  <NavLink
                    className="text-white d-none d-xl-block"
                    to="/course/#ultra"
                  >
                    대회 코스
                  </NavLink>
                </Col>
                <Col>
                  <NavLink
                    className="text-white d-none d-xl-block"
                    to="/apply/individual"
                  >
                    참 가 신 청
                  </NavLink>
                </Col>
                <Col>
                  <NavLink
                    className="text-white d-none d-xl-block"
                    to="/record"
                  >
                    기 록 조 회
                  </NavLink>
                </Col>
                <Col>
                  <NavLink
                    className="text-white d-none d-xl-block"
                    to="/dashboard/notice?pageNo=1"
                  >
                    게 시 판
                  </NavLink>
                </Col>
              </Row>

              {/* mobile nav bar */}
              <NavDropdown title="대회안내" className="ms-4 d-block d-xl-none">
                <NavDropdown.Item href="/guide/#outline">
                  대회 안내
                </NavDropdown.Item>
                <NavDropdown.Item href="/guide/#howto">
                  참가 신청 방법
                </NavDropdown.Item>
                <NavDropdown.Item href="/guide/#prize">시 상</NavDropdown.Item>
                <NavDropdown.Item href="/guide/#gift">기념품</NavDropdown.Item>
                <NavDropdown.Item href="/guide/#note">
                  유의사항
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="대회 코스" className="ms-4 d-block d-xl-none">
                {/* <NavDropdown.Item href="/course/#ultra">
                  울트라35
                </NavDropdown.Item> */}
                <NavDropdown.Item href="/course/#half">
                  하프코스
                </NavDropdown.Item>
                <NavDropdown.Item href="/course/#mini">
                  미니코스
                </NavDropdown.Item>
                <NavDropdown.Item href="/course/#health">
                  건강코스
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="참가신청" className="ms-4 d-block d-xl-none">
                <NavDropdown.Item href="/apply/individual">
                  개인 신청
                </NavDropdown.Item>
                <NavDropdown.Item href="/apply/group">
                  단체 신청
                </NavDropdown.Item>
                <NavDropdown.Item href="/apply/search">
                  조회 및 수정
                </NavDropdown.Item>
                <NavDropdown.Item href="/apply/searchId">
                  접수 번호 조회
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="기록조회" className="ms-4 d-block d-xl-none">
                <NavDropdown.Item href="/record">
                  개인 기록 조회
                </NavDropdown.Item>
                <NavDropdown.Item href="/record/total">
                  종합 기록 조회
                </NavDropdown.Item>
                <NavDropdown.Item href="/record/rank">
                  언텍트 순위
                </NavDropdown.Item>
                <NavDropdown.Item href="/record/untact">
                  언텍트 기록
                </NavDropdown.Item>
                {/* <NavDropdown.Item href="/record/print-record">
                  기록증 출력
                </NavDropdown.Item> */}
              </NavDropdown>
              <NavDropdown title="게시판" className="ms-4 d-block d-xl-none">
                <NavDropdown.Item href="/dashboard/notice?pageNo=1">
                  공지사항
                </NavDropdown.Item>
                <NavDropdown.Item href="/dashboard/qna?pageNo=1">
                  Q&A
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {showNavItem && <NavItem />}
    </div>
  );
};
export default DcNav;
